import gql from 'graphql-tag'

export const PAGE_QUERY = gql`
  {
    banners {
      results {
        id
        title
        subtitle
        externalUrl
        startedAt
        isLimited
        searchQuery
        endedAt
        backgroundColor
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/containers/organisms/MustHeader/graphql.js